import React, {useContext, useEffect, useState} from "react";
import ConferenceGame from "./ConferenceGame";
import GameChat from "./GameChat";
import ModalBox from "./ModalBox";
import VideoChatModal from "./VideoChatModal";
import {AppContext} from "../AppContext";
import {useHistory, useParams} from "react-router-dom";
import {CircularProgress} from "@material-ui/core";
import GameOverlayModalBox from "./GameOverlayModalBox";
import VideoBroadcastOverlayModalBox from "./VideoBroadcastOverlayModalBox";
import VideoStreamManager from "./admin/VideoStreamManager";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import {GameContext, GameProvider} from "./GameContext";
import VideoBroadcastTopLeft from "./VideoBroadcastTopLeft";

export default function GameInterface(props) {
    const appContext = useContext(AppContext)

    const {eventId} = useParams()
    const [selectedEvent, setSelectedEvent] = useState(null)

    const [talkingStart, setTalkingStart] = useState(null)
    const [chatMessages, setChatMessages] = useState([])
    const [videoChatRoomName, setVideoChatRoomName] = useState(null)
    const [showPlayerProfile, setShowPlayerProfile] = useState(null)
    const [showPlayerInfoCallback, setShowPlayerInfoCallback] = useState(null)

    const [gameOverlayMessage, setGameOverlayMessage] = useState(null)
    const [videoOverlay, setVideoOverlay] = useState(null)

    const [controlBarHeight, resizeGameWindow] = useGameSize()
    const [gameWidth, setGameWidth] = useState(200)

    const resizeGameWindowTrigger = () => {
        setTimeout(resizeGameWindow, 200)
    }

    const {updateCurrentEvent} = props

    useEffect(() => {
        let url = `${process.env.REACT_APP_API_CALL}/events/${eventId}`;
        fetch(url,
        {credentials: 'include'})
            .then(response => response.json())
            .then(event => {
                setSelectedEvent(event)
                updateCurrentEvent(event)

                resizeGameWindowTrigger()
            })

    }, [eventId, updateCurrentEvent])

    useEffect(() => {
        const resizeInterval = setInterval(() => {
            const gameWrapper = document.getElementById("gameWrapper")
            if (gameWrapper) {
                const w = gameWrapper.offsetWidth - 10
                if (w !== gameWidth) {
                    setGameWidth(w)
                }
            }
        }, 250)

        return () => clearInterval(resizeInterval)
    }, [])

    const showVideoChat = (roomName) => {
        setVideoChatRoomName(roomName)
    }

    const hideVideoChat = () => {
        setVideoChatRoomName(null)
    }

    const showPlayerInfo = (info, callback) => {
        setShowPlayerProfile(info)
        if(callback)
            setShowPlayerInfoCallback({
                callback: callback
            })
    }

    const stopShowingPlayerInfo = () => {
        setShowPlayerProfile(null)
        if(showPlayerInfoCallback)
        { // noinspection JSValidateTypes
            showPlayerInfoCallback.callback()
        }
        setShowPlayerInfoCallback(null)
    }

    const stopShowingGameOverlay = () => {
        setGameOverlayMessage(null)
        if(gameOverlayMessage.callback){
            gameOverlayMessage.callback()
        }
    }

    const startTalking = (start) => {
        if (talkingStart == null)
            setTalkingStart(start)
    }

    const controlAreaStyle = {
        display: "flex",
        flexDirection: "column",
        minWidth: "500px",
        height: `${controlBarHeight}px`,
        padding: "5px"
    }

    return selectedEvent ? (
            <GameProvider options={{event:selectedEvent}}>
                <div className="App-game">
                    <div className="Game-wrapper" id="gameWrapper">
                        <ConferenceGame
                            selectedEvent={selectedEvent}
                            gameWidth={gameWidth}
                            gameHeight={controlBarHeight}
                            appContext={appContext}
                            videoChatRoomName={videoChatRoomName}
                            showVideoChat={showVideoChat}
                            hideVideoChat={hideVideoChat}
                            talking={talkingStart != null}
                            startTalking={startTalking}
                            cancelTalking={()=>{
                                if(talkingStart != null)
                                    setTalkingStart(null)
                            }}
                            sendMessageCallback={sendMessageCallback}//Oh shit
                            showMessage={(m, playerInfo) => {
                                let message = {message: m, playerInfo: playerInfo};
                                setChatMessages([...chatMessages, message])
                            }}
                            showPlayerInfo={showPlayerInfo}
                            gameOverlayMessage={gameOverlayMessage}
                            setGameOverlayMessage={setGameOverlayMessage}
                            setVideoOverlay={setVideoOverlay}
                        />
                    </div>

                    <div style={controlAreaStyle}>
                        <VideoAdminPanel resizeGameWindowTrigger={resizeGameWindowTrigger}/>
                        <VideoBroadcastTopLeft videoOverlay={videoOverlay}/>
                        <GameChat
                            talking={talkingStart != null}
                            talkingStart={talkingStart}
                            imNotTalkin={() => {
                                setTalkingStart(null)
                            }}
                            startTalking={startTalking}
                            sendMessage={(m) => {
                                sendMessageCallback.send(m)
                            }}
                            chatMessages={chatMessages}
                        />
                    </div>

                    {videoChatRoomName ? <VideoChatModal hideVideoChat={hideVideoChat} videoChatRoomName={videoChatRoomName}/> : null}

                    <ModalBox showPlayerProfile={showPlayerProfile} stopShowingPlayerInfo={stopShowingPlayerInfo}/>
                    <GameOverlayModalBox gameOverlayMessage={gameOverlayMessage} stopShowingGameOverlay={stopShowingGameOverlay}/>
                    <VideoBroadcastOverlayModalBox videoOverlay={videoOverlay}/>
                </div>
            </GameProvider>

    ) : (
        <CircularProgress/>
    )
}

function VideoAdminPanel(props) {
    const gameContext = useContext(GameContext)
    const history = useHistory();

    return <div id="videoAdminContainer">
        {gameContext.isHost && gameContext.event &&
        <VideoStreamManager event={gameContext.event} resizeTrigger={props.resizeGameWindowTrigger} roomInfo={gameContext.venue.videoAdminPanel(gameContext.currentRoom)}/>
        }
        {gameContext.isHost && gameContext.event &&
        <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
                {gameContext.event.name}
            </Typography>
            <Button
                variant="contained"
                color="primary"
                onClick={() => history.push(`/admin/eventvenue/${gameContext.event.id}`)}
            >
                Edit Admin Info
            </Button>
        </Grid>
        }
    </div>
}

/**
 * Ugly callback hook. I don't understand react yet.
 */
class MessageCallback {
    constructor() {
        this.callback = (m)=>{}
    }
    send(m){
        this.callback(m)
    }
}

function useGameSize() {
    const [controlBarHeight, setControlBarHeight] = useState(window.innerHeight - 88)

    const resizeGameWindow = () => {
        setControlBarHeight(window.innerHeight - 88)
    }

    useEffect(() => {
        window.addEventListener("resize", resizeGameWindow, false);
        return () => window.removeEventListener("resize", resizeGameWindow, false)
    }, [])

    return [controlBarHeight, resizeGameWindow]
}

//This is trashy
const sendMessageCallback = new MessageCallback()
